module.exports = __webpack_public_path__ + "static/img/floor3-gymsg.71f7d26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dh-map/floor3-gymsg.png
// module id = blQR
// module chunks = 1